<template>
  <a-card :bordered="false">
    <!-- 工具栏 -->
    <div class="table-operator" style="margin-bottom:12px;">
      <a-input-search v-model="query.name" placeholder="账户名称/卡号" style="width:240px;" @search="loadList" />
      <h-select v-model="query.accountType" placeholder="账户类型" style="width:140px;margin-left:8px;" :options="accountTypeOptions" @change="loadList" />
      <h-select v-model="query.enabled" placeholder="状态" style="width:120px;margin-left:8px;" :options="enabledOptions" @change="loadList" />
      <a-button type="primary" style="margin-left:8px;" icon="sync" @click="loadList">刷新</a-button>
      <a-button style="margin-left:8px;" icon="swap" @click="doQuickTransfer(null)">快捷转账</a-button>
    </div>

    <!-- 列表 -->
    <a-table bordered size="middle" rowKey="id" :columns="cols" :dataSource="rows" :pagination="pag" @change="(p)=>{pag.current=p.current;pag.pageSize=p.pageSize;loadList();}" :loading="loading">
      <template slot="enabled_slot" slot-scope="t, r">
        <a-tag :color="t==='1'||t===true?'green':'default'">{{ t==='1'||t===true?'启用':'停用' }}</a-tag>
      </template>
      <template slot="pay_slot" slot-scope="t">
        <a-tag v-if="t==='1'||t===true" color="blue">启用</a-tag>
        <span v-else class="muted">—</span>
      </template>
      <template slot="type_slot" slot-scope="t">{{ accountTypeLabel(t) }}</template>
      <template slot="masked_slot" slot-scope="t"><span class="mono">{{ t || '—' }}</span></template>
      <template slot="action" slot-scope="t, r">
        <a @click="openEdit(r)">编辑扩展</a>
        <a-divider type="vertical"/>
        <a @click="toggleEn(r)">{{ r.enabled==='1'||r.enabled===true?'停用':'启用' }}</a>
        <a-divider type="vertical"/>
        <a @click="doQuickTransfer(r)">转账</a>
      </template>
    </a-table>

    <!-- 编辑扩展抽屉（account_type + 支付扩展 + 手续费规则） -->
    <a-drawer :title="form.id ? ('编辑扩展 · ' + (form.name||'')) : '新增扩展'" placement="right" :width="620" :visible="drawer" @close="drawer=false" :maskClosable="false">
      <a-form layout="vertical">
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-item label="账户类型">
              <a-select v-model="form.account_type" placeholder="请选择">
                <a-select-option value="现金">现金</a-select-option>
                <a-select-option value="银行卡">银行卡</a-select-option>
                <a-select-option value="微信">微信商户/零钱</a-select-option>
                <a-select-option value="支付宝">支付宝商户</a-select-option>
                <a-select-option value="其他">其他货币资金</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="手续费入账科目">
              <a-select v-model="form.fee_subject_code" :options="subjectOpts" placeholder="默认 6603 财务费用" showSearch optionFilterProp="label"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="启用支付扩展">
              <a-switch checkedChildren="开" unCheckedChildren="关" v-model="form.pay_enabled"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="手续费承担方">
              <a-select v-model="form.fee_bear_side">
                <a-select-option value="payee">收款方承担(默认)</a-select-option>
                <a-select-option value="payer">付款方承担</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>

        <a-divider orientation="left" v-if="form.pay_enabled">支付扩展配置（对接三方支付时填写）</a-divider>
        <a-row :gutter="16" v-if="form.pay_enabled">
          <a-col :span="12">
            <a-form-item label="支付渠道"><a-select v-model="form.pay_channel"><a-select-option v-for="c in channels" :key="c" :value="c">{{ c }}</a-select-option></a-select></a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="商户号 mch_id"><a-input v-model="form.mch_id"/></a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="应用 app_id"><a-input v-model="form.app_id"/></a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="子商户 sub_mch_id"><a-input v-model="form.sub_mch_id"/></a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="加密密钥 api_key / 证书密码（后端 AES 落库）">
              <a-password v-model="form.api_key_cipher"/>
            </a-form-item>
          </a-col>
        </a-row>

        <a-divider orientation="left">手续费规则（ext_config.feeRules · 按8场景分别设置费率%）</a-divider>
        <a-table size="small" bordered :pagination="false" :columns="feeCols" :dataSource="feeRules" rowKey="scene">
          <template slot="rate_slot" slot-scope="tx, row">
            <a-input-number size="small" :min="0" :max="100" :precision="4" v-model="row.ratePct" style="width:120px;"/>
            <span class="muted" style="margin-left:4px;">%</span>
          </template>
          <template slot="cap_slot" slot-scope="tx, row">
            <a-input-number size="small" :min="0" :precision="2" v-model="row.capPerDeal" style="width:120px;"/>
            <span class="muted" style="margin-left:4px;">元/笔</span>
          </template>
        </a-table>
      </a-form>
      <div slot="footer">
        <a-button @click="drawer=false">取消</a-button>
        <a-button type="primary" :loading="saving" style="margin-left:8px;" @click="saveExt">保存</a-button>
      </div>
    </a-drawer>

    <!-- 快捷转账 Modal → 跳转到财务管理收款/转账 单入口（本期仅开转账单） -->
    <a-modal title="快捷转账" :visible="transferVisible" :maskClosable="false" @cancel="transferVisible=false" :footer="null" :width="520">
      <p class="muted">跳转到【财务管理 → 转账单】页面，创建转账单（转出账户已预填）。</p>
      <a-form layout="vertical">
        <a-form-item label="转出账户">
          <a-select v-model="transferForm.outAccountId" :options="accountOpts" showSearch optionFilterProp="label" placeholder="请选择"/>
        </a-form-item>
        <a-form-item label="转账金额">
          <a-input-number :min="0" :precision="2" v-model="transferForm.amount" style="width:100%;"/>
        </a-form-item>
      </a-form>
      <div style="text-align:right;margin-top:12px;">
        <a-button @click="transferVisible=false">取消</a-button>
        <a-button type="primary" style="margin-left:8px;" @click="goTransfer">创建转账单 →</a-button>
      </div>
    </a-modal>
  </a-card>
</template>

<script>
import {
  finAccountList, finAccountSaveExt, finAccountToggleEnabled, finAccountQuickTransfer, finAccountSubjectBindOptions
} from './api'

const LEGAL_FEE_SCENES = [
  { scene: 'retail', label: '零售出库' },
  { scene: 'sale', label: '销售出库' },
  { scene: 'retail_return', label: '零售退货(负)' },
  { scene: 'sale_return', label: '销售退货(负)' },
  { scene: 'sale_order_deposit', label: '销售订单订金' },
  { scene: 'receipt', label: '财务收款' },
  { scene: 'advance_receipt', label: '财务预收' },
  { scene: 'misc_income', label: '财务杂项收入' }
]

export default {
  name: 'FinAccountList',
  data() {
    return {
      loading: false, saving: false,
      query: { name: undefined, accountType: undefined, enabled: undefined },
      rows: [], pag: { current: 1, pageSize: 20, total: 0 },
      drawer: false, form: {},
      transferVisible: false, transferForm: { outAccountId: null, amount: null },
      subjectOpts: [], accountOpts: [],
      channels: ['微信支付', '支付宝', '银联', '通联', '拉卡拉', '其他'],
      accountTypeOptions: [
        { value: '', label: '全部' },
        { value: '现金', label: '现金' }, { value: '银行卡', label: '银行卡' },
        { value: '微信', label: '微信' }, { value: '支付宝', label: '支付宝' }, { value: '其他', label: '其他' }
      ],
      enabledOptions: [{ value: '', label: '全部' }, { value: '1', label: '启用' }, { value: '0', label: '停用' }],
      feeCols: [
        { title: '场景', dataIndex: 'label', width: 170 },
        { title: '费率%', dataIndex: 'ratePct', scopedSlots: { customRender: 'rate_slot' } },
        { title: '单笔封顶(本期预留)', dataIndex: 'capPerDeal', scopedSlots: { customRender: 'cap_slot' } }
      ],
      cols: [
        { title: '操作', dataIndex: 'action', scopedSlots: { customRender: 'action' }, width: 200, fixed: 'left' },
        { title: '账户名称', dataIndex: 'name', width: 170 },
        { title: '账户类型', dataIndex: 'account_type', scopedSlots: { customRender: 'type_slot' }, width: 110 },
        { title: '卡号/账号(脱敏)', dataIndex: 'serial_no_masked', scopedSlots: { customRender: 'masked_slot' }, width: 200 },
        { title: '启用', dataIndex: 'enabled', scopedSlots: { customRender: 'enabled_slot' }, width: 80 },
        { title: '支付扩展', dataIndex: 'pay_enabled', scopedSlots: { customRender: 'pay_slot' }, width: 90 },
        { title: '手续费科目', dataIndex: 'fee_subject_code', width: 110 },
        { title: '商户号 mch_id', dataIndex: 'mch_id_masked', scopedSlots: { customRender: 'masked_slot' }, width: 150 },
        { title: '备注', dataIndex: 'remark', width: 160 }
      ]
    }
  },
  computed: {
    feeRules: {
      get() {
        try {
          const obj = typeof this.form.ext_config === 'string' ? JSON.parse(this.form.ext_config || '{}') : (this.form.ext_config || {})
          const rules = Array.isArray(obj.feeRules) ? obj.feeRules : []
          return LEGAL_FEE_SCENES.map(s => {
            const ex = rules.find(r => r.scene === s.scene) || {}
            return { scene: s.scene, label: s.label, ratePct: ex.ratePct || null, capPerDeal: ex.capPerDeal || null }
          })
        } catch (e) { return LEGAL_FEE_SCENES.map(s => ({ scene: s.scene, label: s.label })) }
      },
      set(val) {
        const arr = val.filter(v => v.ratePct != null && Number(v.ratePct) > 0).map(v => ({
          scene: v.scene, ratePct: Number(v.ratePct), capPerDeal: v.capPerDeal == null ? null : Number(v.capPerDeal)
        }))
        const cur = typeof this.form.ext_config === 'string' ? JSON.parse(this.form.ext_config || '{}') : (this.form.ext_config || {})
        cur.feeRules = arr
        this.form.ext_config = JSON.stringify(cur)
      }
    }
  },
  created() { this.loadList(); this.loadSubjects(); this.loadAccounts() },
  methods: {
    loadList() {
      this.loading = true
      const p = {
        page: this.pag.current, pageSize: this.pag.pageSize,
        name: this.query.name, accountType: this.query.accountType,
        enabled: this.query.enabled
      }
      finAccountList(p).then(r => {
        this.loading = false
        if (r && r.success) {
          const d = r.data || {}
          this.rows = d.rows || []
          this.pag.total = d.total || 0
        } else { this.$message.error((r && r.message) || '查询失败') }
      }).catch(() => { this.loading = false; this.$message.error('请求失败') })
    },
    loadSubjects() {
      finAccountSubjectBindOptions({}).then(r => { if (r && r.success) this.subjectOpts = (r.data || []).map(x => ({ value: x.code, label: (x.code + ' ' + x.name) })) })
    },
    loadAccounts() {
      finAccountList({ page: 1, pageSize: 500, enabled: '1' }).then(r => { if (r && r.success) this.accountOpts = ((r.data || {}).rows || []).map(x => ({ value: x.id, label: (x.name + (x.account_type ? ' (' + x.account_type + ')' : '')) })) })
    },
    accountTypeLabel(t) { return t || '—' },
    openEdit(r) {
      this.form = Object.assign({}, r || {})
      // 保证 ext_config 是字符串（写回后端时原样保存）
      if (!this.form.ext_config) this.form.ext_config = '{}'
      this.drawer = true
    },
    saveExt() {
      this.saving = true
      const p = Object.assign({}, this.form, { ext_config: typeof this.form.ext_config === 'string' ? this.form.ext_config : JSON.stringify(this.form.ext_config || {}) })
      finAccountSaveExt(p).then(r => {
        this.saving = false
        if (r && r.success) { this.$message.success('保存成功'); this.drawer = false; this.loadList() } else { this.$message.error((r && r.message) || '保存失败') }
      }).catch(() => { this.saving = false; this.$message.error('请求失败') })
    },
    toggleEn(r) {
      finAccountToggleEnabled({ id: r.id }).then(res => {
        if (res && res.success) { this.$message.success('操作成功'); this.loadList() } else { this.$message.error((res && res.message) || '失败') }
      })
    },
    doQuickTransfer(r) {
      this.transferForm.outAccountId = r ? r.id : null
      this.transferForm.amount = null
      this.transferVisible = true
    },
    goTransfer() {
      // 跳转到 财务管理→转账单（使用路由；不存在时降级打开 account_head 新建入口）
      const route = this.$router.resolve({ path: '/finance/accountHead', query: { type: '转账', outAccountId: this.transferForm.outAccountId, amount: this.transferForm.amount } })
      window.open(route.href, '_blank')
      this.transferVisible = false
    }
  }
}
</script>

<style scoped>
.muted{color:#999;}
.mono{font-family:Consolas,monospace;}
</style>
